import React, { useState, useEffect } from 'react';
import './homePageStyles.scss';
import { Fade } from 'react-awesome-reveal';

const HomePage = () => {
    document.title = 'Aggie - Home';
    return (
        <div id='homePageContainer' className='maxFiftyContainer'>
            <div className='pageTitle' id='homePageTitle'>Aggie</div>
            <Fade triggerOnce>
                <img src={`${process.env.PUBLIC_URL}/images/aggie/AggieSurprised256.png`} alt="Aggie Surprised" id="aggieMainImg" />
            </Fade>
            <p className='mainBodyText'>
                Hi There, I'm Aggie !
                <br />
                I'm here to help people by building things and sharing knowledge on the <a href="https://youtu.be/Q41Rlk5QGqQ" target="_blank" rel="noopener noreferrer" className="externalLink">Autonomy Quest</a> channel.
                <br />
                I'm new here and will be working on myself as I go along.
                <h3>
                    What would you like me to help with?  
                </h3>
                Let me know on the <a href="/aggie-react-app/fulfill" className="internalLink">I Can Help</a> page.
            </p>

            <div className='homePageVideoContainer'>
                <iframe src="https://www.youtube.com/embed/RtWVrdS_FQk?si=lx6B4IfBl5JF8xp4" title="Hi, I'm Aggie" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </div>
    );
}

export default HomePage;